
import dayjs from 'dayjs';

const today=new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

interface PNCDetail {
    pnc: number;
    start: number;
    end: number;
};

interface PNCResult {
    pnc: number;
    startDate: string;
    endDate: string;
};

export const DELIVERY_ERRORS = {
    DATE_OF_DELIVERY: 'Date of delivery cannot be blank.',
    TIME_OF_DELIVERY: 'Time of delivery cannot be blank.',
    TYPE_OF_DELIVERY: 'Type of delivery cannot be blank.',
    PLACE_OF_DELIVERY: 'Place of delivery cannot be blank.',
    TAB_MISOPROSTOL_GIVEN: 'Whether Tab Misoprostol given cannot be blank.',
    WHETHER_CONDUCTED_SKILLED_PERSON: 'Whether conducted skilled person cannot be blank.',
    DELIVERY_COMPLICATIONS: 'Delivery complications cannot be blank.',
    STILL_BIRTH: 'No of still birth cannot be blank.',
    STILL_BIRTH_TYPE: 'Still birth type cannot be blank.',
    LIVE_BIRTH: 'Live birth cannot be blank.',
    PPIUCD: 'PPIUCD cannot be blank.',
    PPIUCD_TYPE: 'PPUICD Inserted Type cannot be blank.',
    DATE_OF_DISCHARGE: 'Date of discharge cannot be blank.',
    TIME_OF_DISCHARGE: 'Time of discharge cannot be blank.',
    STILL_BIRTH_COUNT_GREATER_THAN_4: 'Still birth count cannot be greater than 4',
    LIVE_BIRTH_COUNT_GREATER_THAN_4: 'Live birth count cannot be greater than 4',
};

export const DELIVERY_TOAST_MESSAGE = {
    LIVE_STILL_BIRTH_COUNT_GREATER_THAN_4:'Live birth and still birth count is more than 4, please check once.',
    LIVE_STILL_BIRTH_EMPTY: 'Live birth and still birth both cannot be empty or zero',
    DELIVERY_SUCCESS: 'Delivery Details have been successfully created',
    DELIVERY_CHILD_SUCCESS: 'Delivery & Child Details have been successfully created',
    FORM_CHANGED: 'You have unsaved changes. Are you sure you want to leave without saving?'
}

export const CHILD_MIN_BIRTH_WEIGHT_GMS = 500;

export const CHILD_ERRORS = {
    NAME: 'Child name cannot be blank.',
    DOB: 'DOB cannot be blank. Select valid DOB.',
    GENDER: 'Gender cannot be blank. Select valid gender.',
    RELATION: 'Relation with Child cannot be blank. Select valid relation with Child.',
    TIME_OF_BIRTH: 'Time of birth cannot be blank. Select valid Time of Birth.',
    MATURITY: 'Maturity cannot be blank. Select valid maturity.',
    WEIGHT: 'Weight cannot be blank. Please enter valid weight.',
    WEIGHT_IN_GMS: 'Weight cannot be less than 500gms',
    WEIGHT_IN_HIGH_GMS: 'Weight cannot be greater than 10000gms',
    ABHA_ID: 'ChildAbha cannot be blank. Please enter valid childAbha.',
    MOTHER_ALIVE: 'Is Mother alive cannot be blank.',
    FATHER_NAME: 'Father Name cannot be blank. Please enter valid Father name.',
    FATHER_PHONE_NUMBER: 'Father Phone number cannot be blank. Please enter valid Phone number.',
    GUARDIAN_NAME: 'Guardian Name cannot be blank. Please enter valid guardian name.',
    GUARDUAN_PHONE_NUMBER: 'Guardian Phone number cannot be blank. Please enter valid Phone number.',
    ADD_ALL_CHILD_DETAILS: 'Please add all the child details.',
    UPDATE_REQUIRED_FIELDS: `Valid child ID, name, gender, DOB, maturity and birth weight (at least ${CHILD_MIN_BIRTH_WEIGHT_GMS}gms) are required.`,
    
}

export const DELIVERY_DATE_FORMATS = {
    DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
    TIME: 'HH:mm',
    DATE: 'YYYY-MM-DD',
}

export const DELIVERY_COMMON_CONSTANTS = {
    YES: 'Yes',
    NO: 'No',
    VALUE: 'value',
    ID: 'id',
    CODE: 'code',
    DAY: 'day',
    WEEK: 'week',
    NO_COMPLICATIONS: 'No Complications',
    HOME: 'Home',
    DELIVERY_COMPLICATION: 'delivery_complications',
    TYPE_OF_DELIVERY: 'type_of_delivery',
    SUCCESS: 'success',
    ABORTION:'abortion',
    STILL_BIRTH: 'still_birth',
    STILLBIRTH: 'still birth',
    INSTITUTIONAL: 'institutional',
    COULD_NOT_BE_DETERMINED: 'Could Not be Determined',
}

export const getPNCDetails = (deliveryDate: string): PNCResult[] => {
    const pncDetails: PNCDetail[] = [
        { pnc: 1, start: 0, end: 1 },
        { pnc: 2, start: 2, end: 5 },
        { pnc: 3, start: 6, end: 12 },
        { pnc: 4, start: 13, end: 19 },
        { pnc: 5, start: 20, end: 26 },
        { pnc: 6, start: 27, end: 40 },
        { pnc: 7, start: 41, end: 44 }
    ];
  
    const delivery = dayjs(deliveryDate);  
    const results = pncDetails.map(pnc => {
        const startDate = delivery.add(pnc.start, 'day').format('YYYY-MM-DD');
        const endDate = delivery.add(pnc.end, 'day').format('YYYY-MM-DD');
        return {
            pnc: pnc.pnc,
            startDate,
            endDate
        };
    });
  
    return results;
  };
  